/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FontPickerIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Font Picker',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m10.73535,12.20996L6.71777,2.72852c-.11719-.27686-.38867-.45703-.68848-.45752h-.00195c-.2998,0-.57129.17871-.68945.45459L1.2666,12.22559c-.16309.38086.01367.82178.39355.98486.09668.04102.19727.06055.2959.06055.29102,0,.56738-.17041.68945-.45459l1.18506-2.76514h4.36133l1.1626,2.74365c.16113.38184.60059.55859.9834.39795.38086-.16162.55957-.60156.39746-.98291Zm-6.26196-3.65869l1.55005-3.61719,1.53271,3.61719h-3.08276Z"
      fill="currentColor"
    />
    <path
      d="m18.57617,14.75684c-.53613-2.07617-2.8457-2.03564-4.08594-2.01758-.65723.01709-1.16016-.125-1.32129-.36328-.10095-.14868-.10522-.40918-.03674-.73315.32263.11694.66357.18579,1.01624.18579.0166,0,.0332-.00049.05078-.00049,1.64844-.02734,2.9668-1.39062,2.93945-3.03857-.00525-.31494-.07178-.61072-.16626-.89307h.57739c.41406,0,.75-.33594.75-.75s-.33594-.75-.75-.75h-1.6991c-.49536-.34253-1.09656-.54736-1.7511-.54736-.79883.01318-1.54395.33691-2.09961.91064-.55469.57373-.85254,1.32959-.83984,2.12744.01086.68262.26025,1.3186.6875,1.83813-.35034.99268-.34851,1.81909.04688,2.44214-.66602.4375-1.35938,1.19336-1.38184,2.27344-.01367.69775.23926,1.32812.7334,1.82373.67969.68262,1.75195,1.05566,3.02637,1.05566.03613,0,.07324-.00049.10938-.00098,1.62402-.02686,2.98047-.60107,3.72266-1.57471.4668-.61279.63867-1.3374.47168-1.98779Zm-5.49707-6.9541c.27637-.28613.64746-.44727,1.0459-.45361.00781,0,.0166-.00049.02441-.00049.81055,0,1.47559.65234,1.48926,1.46533.01367.82129-.64355,1.50049-1.46484,1.51416-.00781,0-.0166.00049-.02539.00049-.38867,0-.75488-.14844-1.03516-.41943-.28613-.27637-.44727-.64795-.45312-1.0459-.00684-.39795.1416-.7749.41895-1.06055Zm3.83203,8.03271c-.45508.59717-1.41016.96484-2.55469.98389-.875.02344-1.65039-.21436-2.04785-.61377-.20508-.20557-.30176-.4458-.2959-.73389.0166-.82617,1.08496-1.25,1.0918-1.25244.07129-.02686.13672-.06348.19434-.10791.33398.08691.73145.13574,1.2168.12793,1.98047-.03027,2.45215.28809,2.60742.89209.05273.20215-.02539.45898-.21191.7041Z"
      fill="currentColor"
    />
  </svg>`;
};
